/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/miami-indications-pos/miami-indications-pos.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/root/modal/modal.service';
import * as import10 from '../../../../../../../public/upgrade/core/logger.service';
import * as import11 from '@ngx-translate/core/src/translate.service';
import * as import12 from '@ngx-translate/core/src/translate.pipe';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import15 from '../../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import16 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import17 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import18 from '@angular/core/src/linker/element_ref';
import * as import19 from '@angular/core/src/linker/template_ref';
import * as import20 from '@angular/common/src/directives/ng_if';
import * as import21 from '@angular/common/src/directives/ng_class';
import * as import22 from '@angular/core/src/linker/query_list';
import * as import23 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import24 from '@angular/common/src/directives/ng_for';
export class Wrapper_MiamiIndicationsPosComponent {
  /*private*/ _eventHandler:Function;
  context:import0.MiamiIndicationsPosComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this.context = new import0.MiamiIndicationsPosComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  check_isPointOfSale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.isPointOfSale = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_MiamiIndicationsPosComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_MiamiIndicationsPosComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.MiamiIndicationsPosComponent>;
  _MiamiIndicationsPosComponent_0_3:Wrapper_MiamiIndicationsPosComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_MiamiIndicationsPosComponent_Host0,renderType_MiamiIndicationsPosComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'miami-indications-pos',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_MiamiIndicationsPosComponent0(this.viewUtils,this,0,this._el_0);
    this._MiamiIndicationsPosComponent_0_3 = new Wrapper_MiamiIndicationsPosComponent(this.injectorGet(import9.ModalService,this.parentIndex),this.injectorGet(import10.LoggerService,this.parentIndex),this.injectorGet(import11.TranslateService,this.parentIndex));
    this.compView_0.create(this._MiamiIndicationsPosComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._MiamiIndicationsPosComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.MiamiIndicationsPosComponent) && (0 === requestNodeIndex))) { return this._MiamiIndicationsPosComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._MiamiIndicationsPosComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._MiamiIndicationsPosComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const MiamiIndicationsPosComponentNgFactory:import8.ComponentFactory<import0.MiamiIndicationsPosComponent> = new import8.ComponentFactory<import0.MiamiIndicationsPosComponent>('miami-indications-pos',View_MiamiIndicationsPosComponent_Host0,import0.MiamiIndicationsPosComponent);
const styles_MiamiIndicationsPosComponent:any[] = ([] as any[]);
class View_MiamiIndicationsPosComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_translate_0:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_MiamiIndicationsPosComponent2,renderType_MiamiIndicationsPosComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','overlay-block default-instruction-inactive-buttons'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.indications.unavailable')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_MiamiIndicationsPosComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import14.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import13.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import15.Wrapper_NgIf;
  _text_10:any;
  _el_11:any;
  _NgClass_11_3:import14.Wrapper_NgClass;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _NgClass_19_3:import14.Wrapper_NgClass;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _map_42:any;
  /*private*/ _expr_43:any;
  _map_44:any;
  /*private*/ _expr_45:any;
  _pipe_translate_0:import12.TranslatePipe;
  /*private*/ _expr_47:any;
  /*private*/ _expr_48:any;
  _map_49:any;
  /*private*/ _expr_50:any;
  _pipe_translate_1:import12.TranslatePipe;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  /*private*/ _expr_54:any;
  _pipe_translate_2:import12.TranslatePipe;
  /*private*/ _expr_56:any;
  _pipe_translate_3:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_MiamiIndicationsPosComponent1,renderType_MiamiIndicationsPosComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_42 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'card-small-green': p0};
    });
    this._expr_43 = import1.UNINITIALIZED;
    this._map_44 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'default-instruction-inactive-buttons': p0};
    });
    this._expr_45 = import1.UNINITIALIZED;
    this._expr_47 = import1.UNINITIALIZED;
    this._expr_48 = import1.UNINITIALIZED;
    this._map_49 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-disable': p0};
    });
    this._expr_50 = import1.UNINITIALIZED;
    this._expr_52 = import1.UNINITIALIZED;
    this._expr_53 = import1.UNINITIALIZED;
    this._expr_54 = import1.UNINITIALIZED;
    this._expr_56 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12 card-small-content'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','card-small default-instructions-card -eva-3-mb-lg'),(null as any));
    this._NgClass_2_3 = new import14.Wrapper_NgClass(this.parentView.parentView.injectorGet(import16.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import17.KeyValueDiffers,this.parentView.parentIndex),new import18.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','card-small-green-icon'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','eva-3-icon-checkmark-circle -eva-3-tc-green-3 -eva-3-icon-lg'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_9 = new import13.ViewContainer(9,2,this,this._anchor_9);
    this._TemplateRef_9_5 = new import19.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import15.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_2,'h5',new import3.InlineArray2(2,'class','eva-3-h5 -eva-3-pb-lg'),(null as any));
    this._NgClass_11_3 = new import14.Wrapper_NgClass(this.parentView.parentView.injectorGet(import16.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import17.KeyValueDiffers,this.parentView.parentIndex),new import18.ElementRef(this._el_11),this.renderer);
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_2,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_2,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'a',new import3.InlineArray2(2,'class','eva-3-btn-ghost -md'),(null as any));
    this._NgClass_19_3 = new import14.Wrapper_NgClass(this.parentView.parentView.injectorGet(import16.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import17.KeyValueDiffers,this.parentView.parentIndex),new import18.ElementRef(this._el_19),this.renderer);
    this._text_20 = this.renderer.createText(this._el_19,'\n                    ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_19,'\n                ',(null as any));
    this._text_24 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_2,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'dsp-button',new import3.InlineArray4(4,'size','md','variation','ghost'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_26,'dsp-button',new import3.InlineArray4(4,'size','md','variation','link'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_26,'\n            ',(null as any));
    this._text_34 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_35 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_19,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_19));
    this._pipe_translate_1 = new import12.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_28,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_28));
    this._pipe_translate_2 = new import12.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_31,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_31));
    this._pipe_translate_3 = new import12.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import20.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import21.NgClass) && ((11 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._NgClass_11_3.context; }
    if (((token === import21.NgClass) && ((19 <= requestNodeIndex) && (requestNodeIndex <= 23)))) { return this._NgClass_19_3.context; }
    if (((token === import21.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 34)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = 'card-small default-instructions-card -eva-3-mb-lg';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_42(this.parentView.context.addGreenBorder(this.context.$implicit));
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_9_0_0:boolean = !this.parentView.context.isCounter(this.context.$implicit);
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:any = 'eva-3-h5 -eva-3-pb-lg';
    this._NgClass_11_3.check_klass(currVal_11_0_0,throwOnChange,false);
    const currVal_11_0_1:any = this._map_44(this.parentView.context.isHidden(this.context.$implicit));
    this._NgClass_11_3.check_ngClass(currVal_11_0_1,throwOnChange,false);
    this._NgClass_11_3.ngDoCheck(this,this._el_11,throwOnChange);
    const currVal_19_0_0:any = 'eva-3-btn-ghost -md';
    this._NgClass_19_3.check_klass(currVal_19_0_0,throwOnChange,false);
    const currVal_19_0_1:any = this._map_49(!this.parentView.context.isCounter(this.context.$implicit));
    this._NgClass_19_3.check_ngClass(currVal_19_0_1,throwOnChange,false);
    this._NgClass_19_3.ngDoCheck(this,this._el_19,throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    const currVal_43:any = this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_43,currVal_43)) {
      this.renderer.setElementProperty(this._el_4,'hidden',currVal_43);
      this._expr_43 = currVal_43;
    }
    valUnwrapper.reset();
    const currVal_45:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_0.transform(('pointOfSale.meetingType.' + this.context.$implicit))),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_45,currVal_45))) {
      this.renderer.setText(this._text_12,currVal_45);
      this._expr_45 = currVal_45;
    }
    const currVal_47:any = import3.inlineInterpolate(1,'default-instruction-description-',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_47,currVal_47)) {
      this.renderer.setElementProperty(this._el_14,'id',currVal_47);
      this._expr_47 = currVal_47;
    }
    const currVal_48:boolean = !this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_48,currVal_48)) {
      this.renderer.setElementProperty(this._el_17,'hidden',currVal_48);
      this._expr_48 = currVal_48;
    }
    valUnwrapper.reset();
    const currVal_50:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.SELECT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_50,currVal_50))) {
      this.renderer.setText(this._text_22,currVal_50);
      this._expr_50 = currVal_50;
    }
    const currVal_52:any = this.parentView.context.isHidden(this.context.$implicit);
    if (import3.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setElementProperty(this._el_26,'hidden',currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_53:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_53,currVal_53)) {
      this.renderer.setElementProperty(this._el_28,'qadata',currVal_53);
      this._expr_53 = currVal_53;
    }
    valUnwrapper.reset();
    const currVal_54:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.EDIT')),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_54,currVal_54))) {
      this.renderer.setText(this._text_29,currVal_54);
      this._expr_54 = currVal_54;
    }
    valUnwrapper.reset();
    const currVal_56:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.CANCEL')),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_56,currVal_56))) {
      this.renderer.setText(this._text_32,currVal_56);
      this._expr_56 = currVal_56;
    }
  }
  destroyInternal():void {
    this._vc_9.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 9)) { return new View_MiamiIndicationsPosComponent2(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    return (null as any);
  }
  handleEvent_19(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.selectClick(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_28(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.editClick(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_31(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.clear(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_MiamiIndicationsPosComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_MiamiIndicationsPosComponent,{});
export class View_MiamiIndicationsPosComponent0 extends import2.AppView<import0.MiamiIndicationsPosComponent> {
  _viewQuery_defaultInstructionsDescription_0:import22.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import13.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import23.Wrapper_NgFor;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_MiamiIndicationsPosComponent0,renderType_MiamiIndicationsPosComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_defaultInstructionsDescription_0 = new import22.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row cards-small-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import13.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import19.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import23.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.injectorGet(import16.IterableDiffers,this.parentIndex),this.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._viewQuery_defaultInstructionsDescription_0.reset(([] as any[]));
    this.context.description = this._viewQuery_defaultInstructionsDescription_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import24.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.meetingType;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_MiamiIndicationsPosComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/delivery-instructions/miami-indications-pos/miami-indications-pos.component.ngfactory.ts